import React from "react";
import "../../styles/components/ScheduleBook.css";
import moment from "moment";
import helper from "../../utils/helper";
import _ from 'lodash'
import BButton from "../../components/general/BButton";
import { useNavigate } from "react-router-dom";

// helper.CONFIG.MONTH()
const ScheduleBook = ({ date, status, scheduleList = [] }) => {
  let navigate = useNavigate();
  const Mapstatus = (s) => {
    const maps = { "1" : "รออนุมัติ", "2": "อนุมัติ", "3": "ไม่อนุมัติ" };
    return maps[s] ? maps[s] : null;
  };
  const MapSchedule = (s) => {
    const maps = { "1" : "กะเช้า", "2": "กะกลางวัน", "3": "กะดึก" };
    return maps[s] ? maps[s] : null;
  };
  const selectShift = () => {
    const selectDate = moment(date).format('YYYY-MM-DD')
    console.log('selectShift !!!', moment(date).format('YYYY-MM-DD'))
    // navigate(`/schedule-step2?date=${selectDate}`);
    navigate(`/schedule-step2`);
  }
  return (
    <div className="schedule-book">
      <main>
        <h3>
          {moment(date).format("D ")}
          {helper.CONFIG.MONTH[moment(date).format("M")]}
          {moment(date).format(" YYYY")}
        </h3>
        { scheduleList.length
        ? 
        <ul>
          {scheduleList.map((item, index) => (
            <li key={index}>
              <div>{item.ward?.hospital?.hospitalName}: {item.ward?.wardName}</div>
              <div className="schedule-status">
                {console.log(item)}
                <div>{MapSchedule(item.shift)} {moment(item.shiftTimeFrom, 'HH:mm:ss').format('HH:mm')} - {moment(item.shiftTimeTo, 'HH:mm:ss').format('HH:mm')}</div>
                <div>(สถานะ : {Mapstatus(item.statusmain)})</div>
              </div>
            </li>
          ))}
        </ul>
        :
          <div className="no-event-day">
            <div className="icon">
              <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21.2891 7.8125H0.585938C0.263672 7.8125 0 7.54883 0 7.22656V5.46875C0 4.1748 1.0498 3.125 2.34375 3.125H4.6875V0.585938C4.6875 0.263672 4.95117 0 5.27344 0H7.22656C7.54883 0 7.8125 0.263672 7.8125 0.585938V3.125H14.0625V0.585938C14.0625 0.263672 14.3262 0 14.6484 0H16.6016C16.9238 0 17.1875 0.263672 17.1875 0.585938V3.125H19.5312C20.8252 3.125 21.875 4.1748 21.875 5.46875V7.22656C21.875 7.54883 21.6113 7.8125 21.2891 7.8125ZM0.585938 9.375H21.2891C21.6113 9.375 21.875 9.63867 21.875 9.96094V22.6562C21.875 23.9502 20.8252 25 19.5312 25H2.34375C1.0498 25 0 23.9502 0 22.6562V9.96094C0 9.63867 0.263672 9.375 0.585938 9.375ZM13.1494 17.1875L15.498 14.8389C15.7275 14.6094 15.7275 14.2383 15.498 14.0088L14.1162 12.627C13.8867 12.3975 13.5156 12.3975 13.2861 12.627L10.9375 14.9756L8.58887 12.627C8.35938 12.3975 7.98828 12.3975 7.75879 12.627L6.37695 14.0088C6.14746 14.2383 6.14746 14.6094 6.37695 14.8389L8.72559 17.1875L6.37695 19.5361C6.14746 19.7656 6.14746 20.1367 6.37695 20.3662L7.75879 21.748C7.98828 21.9775 8.35938 21.9775 8.58887 21.748L10.9375 19.3994L13.2861 21.748C13.5156 21.9775 13.8867 21.9775 14.1162 21.748L15.498 20.3662C15.7275 20.1367 15.7275 19.7656 15.498 19.5361L13.1494 17.1875Z" fill="#8F8F8F"/>
              </svg>
            </div>

            <h2>คุณไม่มีกะทำงานในวันนี้</h2>
            <br/>
          </div>
        }
      </main>
      {/* { <div className="s-book-footer">
        <BButton setStyle="block" onClick={selectShift}>จองตารางเวร</BButton>
      </div>
      } */}
    </div>
  );
};
export default ScheduleBook;
